// extracted by mini-css-extract-plugin
module.exports = {"container":"solution_container__lebx7","buttons":"solution_buttons__dkokG","vote":"solution_vote__S8the"};